import React, { useState, useRef, useEffect } from 'react';
import { compose } from 'redux';
import { connect, useSelector, useDispatch } from 'react-redux';
import { IoMdArrowDropdown } from 'react-icons/io';
import { useHistory } from 'react-router-dom';
import { setPlanTarget } from '../../../ducks/subscriptionReducer.duck';
import { Formik, Form, ErrorMessage, useFormikContext } from 'formik';
import { FormattedMessage, injectIntl } from 'react-intl';
import * as coreAPI from '../../../coreApi';

import { isNil } from 'lodash';
import { fetchCurrentUser } from '../../../ducks/user.duck';
import ReCaptcha from 'react-google-recaptcha';
import { FaRegEye } from 'react-icons/fa';
import { FaRegEyeSlash } from 'react-icons/fa';
import { GoogleLogin } from 'react-google-login';
import {
    login,
    signInWithGoogle,
    authenticationInProgress,
    signup,
    savereferer,
    signUpWithGoogle,
} from '../../../ducks/Auth.duck';
import { isSignupEmailTakenError } from '../../../util/errors';

import {
    activateRole,
    changeRole,
    updateAccount,
    updateOrganizationDetails,
    getCurrentOrganization,
} from '../../../coreApi';

import CheckBoxInfo from '../../../newComponents/checkbox';
import CustomRadioSelect from '../../../newComponents/SelectRadioDropdown';
import TextField from '../../../newComponents/Form/TextField';
import { OrangeBtn } from '../../../newComponents/Button/ButtonSkin';
import { signupInitialValues } from './SignupInitialValues';
import { signupValScheme } from './SignupValScheme';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import StepForm from '../StepForm';
import { STRIPE_SUPPORTED_TAX_COUNTRIES } from '../../../util/TaxIdTypes';

const InputButton = styled.div`
    color: #2d3748;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
    width: 100%;
    height: 37px;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #a9a9a9;
    padding: 10px;
    .drop-icon {
        right: 12px;
        top: 11px;
        position: absolute;
    }
`;
const Dropdown = styled.ul`
    text-decoration: none;
    text-align: left;
    position: absolute;
    top: 100%;
    left: 0px;
    margin-top: 0px;
    background-color: white;
    font-family: 'Galano Grotesque';
    z-index: 200;
    width: -webkit-fill-available;
    cursor: pointer;
    height: 200px;
    overflow: scroll;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);
`;
const DropdownItem = styled.li`
    text-decoration: none;
    text-align: left;
    position: relative;
    background-color: white;
    padding: 10px;
    cursor: pointer;
    font-family: 'Galano Grotesque';
    &:hover {
        background-color: rgb(253, 253, 253);
    }
    @media screen and (max-width: 500px) {
        position: relative;
        width: auto;
    }
`;

export const Error = styled.div`
    color: #dd6b17;
    line-height: 180%;
    margin-top: 2px;
    font-weight: 600;
    margin-left: 14px;
`;
const StepOneSection = styled.section`
    max-width: 440px;
    .form-title {
        margin-bottom: 29px;
        .title-info {
            font-size: 16px;
            line-height: 180%;
            font-weight: 400;
        }
    }
    .form-section {
        gap: 16px;
        padding: 0 14px;
        .two-col {
            .input-box-section {
                position: relative;
                width: 50%;
            }
        }
    }
    .googleSignUp {
        width: 100%;
        margin: 20px auto;
        text-align: center;
    }
    .googleSignUp h5 {
        font-weight: 500;
        font-size: 18px;
        line-height: 23px;
        color: #000000;
    }
    .googleSignUp > button {
        width: 100%;
        border-radius: 15px;
    }
    .cta {
        max-width: 310px;
        margin-top: 30px;
        margin-bottom: 7px;
        text-align: center;
        button {
            width: 100%;
        }
        .login-cta {
            line-height: 150%;
            margin-top: 8px;
            a {
                font-weight: 600;
                color: ${({ theme }) => theme.colors.title_green};
                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }
    @media (max-width: ${({ theme }) => theme.media.tab}) {
        .form-section {
            gap: 24px;
        }
    }
`;

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || null;
const Signup = props => {
    const {
        isAuthenticated,
        loginError,
        signupError,
        intl,
        currentUser,
        planTarget,
        location,
    } = props;
    const [isLoading, setLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(true);
    const [showError, setShowError] = useState(true);
    const [regularAccError, setRegularAccError] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [isOpenTaxCountry, setOpenTaxCountry] = useState(false);
    const [isOpenTaxIdTypes, setOpenTaxIdTypes] = useState(false);
    const [selectedTaxCountry, setSelectedTaxCountry] = useState('');
    const [taxIdType, setSelectedTaxIdType] = useState('');
    const [taxIdPlaceholderName, setTaxIdPlaceholderName] = useState('');
    const [isExistingOrganization, setIsExistingOrganization] = useState(false);
    const [errorType, setErrorType] = useState(0);

    const currentUserDetails = isAuthenticated
        ? {
              firstName: (currentUser && currentUser.attributes.profile.firstName) || '',
              lastName: (currentUser && currentUser.attributes.profile.lastName) || '',
              email: (currentUser && currentUser.attributes.email) || '',
              password: 'dummytext@123',
              referer: (currentUser && currentUser.attributes.profile.referer) || '',
              planTarget: planTarget || '',
          }
        : {
              firstName: '',
              lastName: '',
              email: '',
              password: '',
              referer: '',
              planTarget: planTarget || '',
          };
    const initialValues = {
        ...signupInitialValues,
        ...currentUserDetails,
        organizationName: '',
        addressLine1: '',
        taxIdType: '',
        taxId: '',
        isAuthenticated,
    };
    console.log('currentUserDetails', signupInitialValues, currentUserDetails, initialValues);

    const [formValues, setFormValues] = useState(initialValues);

    //  refs
    const containerRef3 = useRef(null);
    const containerRef4 = useRef(null);
    // Add dropdown handlers
    const openTaxCountries = () => setOpenTaxCountry(value => !value);
    const openTaxIdTypes = () => setOpenTaxIdTypes(value => !value);
    const dispatch = useDispatch();
    const history = useHistory();
    // Track if the referer value was selected by the user during the authenticated phase
    const [refererSelected, setRefererSelected] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const togglepassword = () => {
        setShowPassword(prevState => !prevState);
    };
    const selectedPlan = useSelector(state => state.subscription.selectedPlan);
    const reCaptchaRefSignup = useRef(null);
    const reCaptchaRefSignupNewsletter = useRef(null);
    const formikRef = useRef();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const resOrg = await getCurrentOrganization();
                if (resOrg.data.length > 0 && currentUser) {
                    const existingOrg = resOrg.data[0];
                    setIsExistingOrganization(true);
                    let taxIdTypeFromDB = '';
                    let taxIdFromDB = '';
                    const taxIds = existingOrg.taxIds;

                    if (taxIds && taxIds.length > 0) {
                        taxIdTypeFromDB = taxIds[0].taxIdType || '';
                        taxIdFromDB = taxIds[0].taxId || '';
                    }

                    const matchedCountry = STRIPE_SUPPORTED_TAX_COUNTRIES.find(country =>
                        country.taxIdTypes.some(type => type.id === taxIdTypeFromDB)
                    );

                    setFormValues(prevValues => ({
                        ...prevValues,
                        firstName: (currentUser && currentUser.attributes.profile.firstName) || '',
                        lastName: (currentUser && currentUser.attributes.profile.lastName) || '',
                        email: (currentUser && currentUser.attributes.email) || '',
                        password: 'dummytext@123',
                        referer: (currentUser && currentUser.attributes.profile.referer) || '',
                        planTarget: planTarget || '',
                        organizationName: existingOrg.organizationName || '',
                        addressLine1: existingOrg.addressLine1 || '',
                        taxIdType: taxIdTypeFromDB,
                        taxId: taxIdFromDB,
                        taxCountry: matchedCountry ? matchedCountry.country : '',
                    }));
                    if (matchedCountry) {
                        setSelectedTaxCountry(matchedCountry);
                    }
                } else {
                    setIsExistingOrganization(false);
                }
            } catch (error) {
                console.error('Error fetching organization details:', error);
            }
        };

        fetchData();
    }, [currentUser, isAuthenticated, planTarget]);

    const handleTaxIdInteraction = () => {
        if (errorType !== null) {
            setErrorType(null);
        }
    };

    const consentLabel = intl.formatMessage({
        id: 'SignupForm.NewsletterForm.Consent',
    });

    const optionsReferer = [
        { name: 'referer', value: <FormattedMessage id="SignupForm.referer.hear" /> },
        { name: 'friends-family', value: <FormattedMessage id="SignupForm.referer.friends" /> },
        { name: 'google', value: <FormattedMessage id="SignupForm.referer.google" /> },
        { name: 'news-media', value: <FormattedMessage id="SignupForm.referer.news" /> },
    ];

    const optionsPlanTarget = [
        { name: 'planTarget', value: <FormattedMessage id="SignupForm.planTarget.whom" /> },
        { name: 'personas', value: <FormattedMessage id="SignupForm.planTarget.myself" /> },
        { name: 'familia', value: <FormattedMessage id="SignupForm.planTarget.family" /> },
        { name: 'empresa', value: <FormattedMessage id="SignupForm.planTarget.organisation" /> },
    ];

    const validationSchema = signupValScheme;

    const onSubmit = async (values, actions) => {
        const {
            organizationName,
            addressLine1,
            taxIdType,
            taxId,
            isAuthenticated,
            planTarget,
            taxCountry,
            ...restValues
        } = values;

        try {
            setLoading(true);
            setShowError(false);

            if (isChecked) {
                await checkCaptchaNewsLetter(restValues);
            }

            let captchaToken;
            if (reCaptchaRefSignup.current) {
                captchaToken = await reCaptchaRefSignup.current.executeAsync();
                reCaptchaRefSignup.current.reset();
            }

            if (!!captchaToken && !!restValues) {
                await props.submitSignup({ ...restValues, captchaToken });

                if (planTarget === 'empresa') {
                    const response = await activateRole('partner');
                    const authToken = response.data;
                    if (authToken) {
                        localStorage.setItem('authToken', authToken);
                    }
                }

                await props.fetchCurrentUser();
            } else {
                console.error('Failed to generate captchaToken');

                return;
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
            setRegularAccError(true);
            setShowError(true);
        }
    };
    let existingOrganization;
    const onContinue = async values => {
        const { planTarget, referer, organizationName, addressLine1, taxIdType, taxId } = values;

        try {
            setLoading(true);
            setShowError(false);
            if (!!referer) {
                if (refererSelected) {
                    try {
                        await updateAccount({ referer });
                        console.log('Account updated with referer:', referer);
                    } catch (err) {
                        console.error('Failed to update account:', err);
                    }
                }

                if (planTarget === 'empresa') {
                    const isPartner = currentUser && currentUser.currentRole === 'partner';
                    const rolePresent =
                        currentUser && currentUser.activatedRoles.includes('partner');
                    if (currentUser && !rolePresent) {
                        const response = await activateRole('partner');
                        const authToken = response.data;
                        if (authToken) {
                            localStorage.setItem('authToken', authToken);
                        }
                    } else if (currentUser && !isPartner) {
                        const response = await changeRole('partner');
                        const authToken = response.data;
                        if (authToken) {
                            localStorage.setItem('authToken', authToken);
                        }
                    }

                    const orgDetails = {
                        organizationName,
                        addressLine1,
                        taxId,
                        taxIdType,
                    };
                    try {
                        try {
                            existingOrganization = await getCurrentOrganization();
                        } catch (error) {
                            if (error.response && error.response.status === 400) {
                                console.warn(
                                    'Organization not found, proceeding to create a new one.'
                                );
                                existingOrganization = null;
                            } else {
                                console.error('Error fetching organization details:', error);
                                return;
                            }
                        }
                        await updateOrganizationDetails(orgDetails);
                    } catch (error) {
                        console.error('Error updating organization details:', error);
                        if (error.response.data === 'Organization already present') {
                            setErrorType(2);
                        } else if (error.response.data === 'invalidTaxId') {
                            setErrorType(3);
                        } else {
                            setErrorType(1);
                        }
                        return;
                    }
                } else {
                    const isFriend = currentUser && currentUser.currentRole === 'friend';

                    if (currentUser && !isFriend) {
                        const response = await changeRole('friend');
                        const authToken = response.data;
                        if (authToken) {
                            localStorage.setItem('authToken', authToken);
                        }
                    }
                }

                await props.fetchCurrentUser();
                dispatch(setPlanTarget(planTarget));
                console.log('oncontineu', selectedPlan);
                if (selectedPlan.plan === 'oneoff') {
                    history.push('/subscription/onetime-payment');
                } else {
                    history.push('/subscription/confirm-plan');
                }
            }
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
            setRegularAccError(true);
            setShowError(true);
        }
    };
    const checkCaptchaNewsLetter = async restValues => {
        let captchaToken;
        if (reCaptchaRefSignupNewsletter.current) {
            captchaToken = await reCaptchaRefSignupNewsletter.current.executeAsync();
            reCaptchaRefSignupNewsletter.current.reset();
        }

        if (!!captchaToken && !!restValues) {
            try {
                await coreAPI.subscribeToNewsLetter(
                    {
                        firstname: restValues.firstName,
                        lastname: restValues.lastName,
                        email: restValues.email,
                        language: intl.locale,
                        statusIfNew: 'subscribed',
                        status: 'subscribed',
                    },
                    captchaToken
                );
            } catch (e) {
                console.log(e);
            }
        }
    };

    const responseGoogle = async response => {
        setShowError(false);
        if (response.tokenId) {
            try {
                let captchaToken;
                if (reCaptchaRefSignup.current) {
                    captchaToken = await reCaptchaRefSignup.current.executeAsync();
                    reCaptchaRefSignup.current.reset();
                }
                await props
                    .submitSignupWithGoogle({
                        tokenId: response.tokenId,
                        captchaToken,
                    })
                    .then(async () => {
                        await activateRole('partner').then(async response => {
                            const authToken = response.data;
                            if (!isNil(authToken)) {
                                localStorage.setItem('authToken', authToken);
                                await props.fetchCurrentUser();
                            }
                        });
                    });
            } catch (error) {
                console.log({ 'Google Sign In Error': error });
            } finally {
                setRegularAccError(false);
                setShowError(true);
            }
        }
    };

    // firstName
    const firstNameLabel = intl.formatMessage({
        id: 'SignupForm.firstNameLabel',
    });
    const firstNamePlaceholder = intl.formatMessage({
        id: 'SignupForm.firstNamePlaceholder',
    });

    // lastName
    const lastNameLabel = intl.formatMessage({
        id: 'SignupForm.lastNameLabel',
    });
    const lastNamePlaceholder = intl.formatMessage({
        id: 'SignupForm.lastNamePlaceholder',
    });

    const emailLabel = intl.formatMessage({
        id: 'SignupForm.emailLabel',
    });
    const emailPlaceholder = intl.formatMessage({
        id: 'SignupForm.emailPlaceholder',
    });

    // password
    const passwordLabel = intl.formatMessage({
        id: 'SignupForm.passwordLabel',
    });
    const passwordPlaceholder = intl.formatMessage({
        id: 'SignupForm.passwordPlaceholder',
    });

    //Organisation Name
    const organizationLabel = intl.formatMessage({
        id: 'SignupForm.organizationLabel',
    });
    const organizationPlaceholder = intl.formatMessage({
        id: 'SignupForm.organizationPlaceholder',
    });

    //Address Line -1
    const addressLabel = intl.formatMessage({
        id: 'SignupForm.addressLabel',
    });

    const addressPlaceholder = intl.formatMessage({
        id: 'SignupForm.addressPlaceholder',
    });

    //Address Line -2
    const addressLabel2 = intl.formatMessage({
        id: 'SignupForm.addressLabel2',
    });

    const addressPlaceholder2 = intl.formatMessage({
        id: 'SignupForm.addressPlaceholder2',
    });

    //Postal Code
    const addressLabel3 = intl.formatMessage({
        id: 'SignupForm.addressLabel3',
    });

    const addressPlaceholder3 = intl.formatMessage({
        id: 'SignupForm.addressPlaceholder3',
    });
    //Tax Country
    const taxCountryLabel = intl.formatMessage({
        id: 'SignupForm.taxCountryLabel',
    });

    const taxCountryPlaceholder = intl.formatMessage({
        id: 'SignupForm.taxCountryPlaceholder',
    });

    //Tax ID
    const taxIdLabel = intl.formatMessage({
        id: 'SignupForm.taxIdLabel',
    });

    const taxIdPlaceholder = intl.formatMessage({
        id: 'SignupForm.taxIdPlaceholder',
    });

    //Tax Type
    const taxTypeLabel = intl.formatMessage({
        id: 'SignupForm.taxTypeLabel',
    });

    const taxTypePlaceholder = intl.formatMessage({
        id: 'SignupForm.taxTypePlaceholder',
    });
    const mandatoryTaxIdTypePlaceholder = props.intl.formatMessage({
        id: 'OrganisationCalculator.Error.MandatoryTaxIdType',
    });

    ///

    const termsLink = (
        <Link to="/terms-of-service" target="_blank">
            <FormattedMessage id="SignupForm.termsAndConditionsLinkText" />
        </Link>
    );

    const privacyLink = (
        <Link to="/privacy-policy" target="_blank">
            <FormattedMessage id="SignupForm.privacyPolicyLinkText" />
        </Link>
    );

    return (
        <StepForm
            plan={selectedPlan.plan}
            step={1}
            isNextDisabled={!isFormValid}
            formikRef={formikRef}
        >
            <StepOneSection className={`mx-auto flex flex-col`}>
                <div className="form-title">
                    <FormattedMessage id="Subscription.StepForm.Step1.title" />
                    <div className="title-info text-center show-tab">
                        <FormattedMessage id="Subscription.StepForm.Step1.desc" />
                    </div>
                </div>
                <Formik
                    innerRef={formikRef}
                    enableReinitialize={true}
                    initialValues={formValues}
                    validationSchema={validationSchema}
                    onSubmit={isAuthenticated ? onContinue : onSubmit}
                    validateOnMount={true}
                >
                    {formik => {
                        const onSelectedTaxCountry = value => {
                            formik.setFieldValue('taxCountry', value.country);
                            setSelectedTaxCountry(value);
                            setSelectedTaxIdType('');
                            setOpenTaxCountry(false);
                            formik.setFieldValue('taxIdType', '');
                        };

                        const onSelectedTaxIdType = value => {
                            formik.setFieldValue('taxIdType', value.id);
                            setSelectedTaxIdType(value.id);
                            setOpenTaxIdTypes(false);
                            setTaxIdPlaceholderName(value.defaultTaxId);
                        };

                        setIsFormValid(formik.isValid);
                        return (
                            <Form onChange={() => setShowError(false)}>
                                <ReCaptcha
                                    ref={reCaptchaRefSignup}
                                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                    size="invisible"
                                />
                                <ReCaptcha
                                    ref={reCaptchaRefSignupNewsletter}
                                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                    size="invisible"
                                />
                                <div className="form-section flex flex-col">
                                    <div className="two-col flex space-between">
                                        <div className="input-box-section">
                                            <TextField
                                                type="text"
                                                label={firstNameLabel}
                                                name="firstName"
                                                placeholder={firstNamePlaceholder}
                                                aria-describedby="firstnamehelp"
                                                value={formik.values.firstName}
                                                className={`form-control  ${formik.touched
                                                    .firstName &&
                                                    formik.errors.firstName &&
                                                    'input-error'}`}
                                                disabled={isAuthenticated}
                                            />
                                        </div>
                                        <div className="input-box-section">
                                            <TextField
                                                type="text"
                                                label={lastNameLabel}
                                                name="lastName"
                                                placeholder={lastNamePlaceholder}
                                                value={formik.values.lastName}
                                                aria-describedby="lastnamehelp"
                                                className={`form-control  ${formik.touched
                                                    .lastName &&
                                                    formik.errors.lastName &&
                                                    'input-error'}`}
                                                disabled={isAuthenticated}
                                            />
                                        </div>
                                    </div>
                                    <div className="one-col">
                                        <div className="input-box-section">
                                            <TextField
                                                type="email"
                                                label={emailLabel}
                                                name="email"
                                                placeholder={emailPlaceholder}
                                                aria-describedby="emailhelp"
                                                className={`form-control  ${formik.touched.email &&
                                                    formik.errors.email &&
                                                    'input-error'}`}
                                                disabled={isAuthenticated}
                                            />
                                        </div>
                                    </div>
                                    {!isAuthenticated && (
                                        <div className="one-col">
                                            <div className="input-box-section">
                                                <div className="input-group relative">
                                                    <TextField
                                                        type={showPassword ? 'text' : 'password'}
                                                        label={passwordLabel}
                                                        name="password"
                                                        placeholder={passwordPlaceholder}
                                                        aria-describedby="passwordhelp"
                                                        className={`form-control  ${formik.touched
                                                            .password &&
                                                            formik.errors.password &&
                                                            'input-error'}`}
                                                        disabled={isAuthenticated}
                                                    />
                                                    <span
                                                        onClick={togglepassword}
                                                        className="input-group-prepend absolute"
                                                    >
                                                        {showPassword ? (
                                                            <FaRegEye />
                                                        ) : (
                                                            <FaRegEyeSlash />
                                                        )}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div className="one-col">
                                        <CustomRadioSelect
                                            name="referer"
                                            classname={`form-control ${
                                                formik.errors.referer ? 'input-error' : ''
                                            }`}
                                            optionsList={optionsReferer}
                                            value={formik.values.referer}
                                            onChange={value => {
                                                formik.setFieldValue('referer', value);
                                                if (
                                                    currentUserDetails.referer === '' &&
                                                    value !== ''
                                                ) {
                                                    setRefererSelected(true);
                                                }
                                            }}
                                            disabled={
                                                isAuthenticated && !!currentUserDetails.referer
                                            }
                                        />
                                        <ErrorMessage
                                            name="referer"
                                            component="span"
                                            className="error-text small"
                                        />
                                    </div>
                                    <div className="one-col">
                                        <CustomRadioSelect
                                            name="planTarget"
                                            optionsList={optionsPlanTarget}
                                            value={formik.values.planTarget}
                                            onChange={value =>
                                                formik.setFieldValue('planTarget', value)
                                            }
                                            disabled={false}
                                            classname={`form-control ${
                                                formik.errors.planTarget ? 'input-error' : ''
                                            }`}
                                        />
                                        <ErrorMessage
                                            name="planTarget"
                                            component="span"
                                            className="error-text small"
                                        />
                                    </div>
                                    {!isAuthenticated && (
                                        <div className="one-col">
                                            <CheckBoxInfo
                                                labelName={consentLabel}
                                                labelId="consent"
                                                checkboxSection="consent-box"
                                                isChecked={isChecked}
                                                onChange={() => setIsChecked(!isChecked)}
                                            />
                                        </div>
                                    )}
                                    {formik.values.planTarget === 'empresa' && (
                                        <>
                                            {isAuthenticated && (
                                                <>
                                                    {/* Organization Name */}
                                                    <div className="one-col input-box-section">
                                                        <TextField
                                                            type="text"
                                                            label={organizationLabel}
                                                            name="organizationName"
                                                            placeholder={organizationPlaceholder}
                                                            className={`form-control ${formik
                                                                .touched.organizationName &&
                                                                formik.errors.organizationName &&
                                                                'input-error'}`}
                                                            value={formik.values.organizationName}
                                                            disabled={isExistingOrganization}
                                                        />
                                                    </div>

                                                    {/* Address */}
                                                    <div className="one-col input-box-section">
                                                        <TextField
                                                            type="text"
                                                            label={addressLabel}
                                                            name="addressLine1"
                                                            placeholder={addressPlaceholder}
                                                            className={`form-control ${formik
                                                                .touched.address &&
                                                                formik.errors.address &&
                                                                'input-error'}`}
                                                            value={formik.values.addressLine1}
                                                        />
                                                    </div>

                                                    <div className="two-col flex space-between">
                                                        <div className="input-box-section">
                                                            <label htmlFor="taxCountry">
                                                                {taxCountryLabel}
                                                            </label>
                                                            <InputButton
                                                                name="taxCountry"
                                                                onClick={openTaxCountries}
                                                                className={
                                                                    formik.errors.taxCountry
                                                                        ? 'input-error'
                                                                        : ''
                                                                }
                                                            >
                                                                {formik.values.taxCountry || (
                                                                    <FormattedMessage id="SignupForm.taxCountryPlaceholder" />
                                                                )}

                                                                <IoMdArrowDropdown className="drop-icon" />
                                                            </InputButton>
                                                            {isOpenTaxCountry && (
                                                                <Dropdown
                                                                    ref={containerRef3}
                                                                    className="dropdown-menu"
                                                                >
                                                                    {STRIPE_SUPPORTED_TAX_COUNTRIES.map(
                                                                        (country, i) => (
                                                                            <DropdownItem
                                                                                key={i}
                                                                                onClick={() =>
                                                                                    onSelectedTaxCountry(
                                                                                        country
                                                                                    )
                                                                                }
                                                                            >
                                                                                {country.country}
                                                                            </DropdownItem>
                                                                        )
                                                                    )}
                                                                </Dropdown>
                                                            )}
                                                        </div>

                                                        {/* Tax ID Type Dropdown */}
                                                        <div className="input-box-section">
                                                            <label htmlFor="taxIdType">
                                                                {taxTypeLabel}
                                                            </label>
                                                            <InputButton
                                                                name="taxIdType"
                                                                onClick={openTaxIdTypes}
                                                                disabled={!selectedTaxCountry}
                                                                className={
                                                                    formik.errors.taxIdType
                                                                        ? 'input-error'
                                                                        : ''
                                                                }
                                                                value={
                                                                    formik.values.taxIdType || ''
                                                                }
                                                            >
                                                                {formik.values.taxIdType || (
                                                                    <FormattedMessage id="SignupForm.taxTypePlaceholder" />
                                                                )}

                                                                <IoMdArrowDropdown className="drop-icon" />
                                                            </InputButton>
                                                            {isOpenTaxIdTypes &&
                                                                selectedTaxCountry && (
                                                                    <Dropdown
                                                                        ref={containerRef4}
                                                                        className="dropdown-menu"
                                                                    >
                                                                        {selectedTaxCountry.taxIdTypes.map(
                                                                            (type, i) => (
                                                                                <DropdownItem
                                                                                    key={i}
                                                                                    onClick={() =>
                                                                                        onSelectedTaxIdType(
                                                                                            type
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    {type.id}
                                                                                </DropdownItem>
                                                                            )
                                                                        )}
                                                                    </Dropdown>
                                                                )}
                                                        </div>
                                                    </div>
                                                    <div className="one-col input-box-section">
                                                        <TextField
                                                            type="text"
                                                            label={taxIdLabel}
                                                            name="taxId"
                                                            placeholder={
                                                                !taxIdType
                                                                    ? mandatoryTaxIdTypePlaceholder
                                                                    : taxIdPlaceholderName
                                                            }
                                                            className={`form-control ${formik
                                                                .touched.taxId &&
                                                                formik.errors.taxId &&
                                                                'input-error'}`}
                                                            value={formik.values.taxId}
                                                            onChange={e => {
                                                                formik.handleChange(e);
                                                                handleTaxIdInteraction();
                                                            }}
                                                            onKeyDown={handleTaxIdInteraction}
                                                            onPaste={handleTaxIdInteraction}
                                                        />
                                                    </div>
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                                {errorType !== null && (
                                    <Error>
                                        {errorType === 1 ? (
                                            <FormattedMessage id="OrganisationCalculator.Error.Field" />
                                        ) : errorType === 2 ? (
                                            <FormattedMessage id="OrganisationCalculator.Error.OrganisationPresent" />
                                        ) : errorType === 3 ? (
                                            <FormattedMessage id="OrganisationCalculator.Error.InvalidTaxId" />
                                        ) : null}
                                    </Error>
                                )}

                                <div className="cta mx-auto">
                                    <OrangeBtn
                                        type="submit"
                                        disabled={!formik.isValid}
                                        className={!formik.isValid ? 'disabled' : null}
                                    >
                                        {isAuthenticated ? (
                                            <FormattedMessage id="NewPartnersPage.Setup.Account.continue" />
                                        ) : (
                                            <FormattedMessage id="Subscription.StepForm.Signup.btn" />
                                        )}
                                    </OrangeBtn>
                                    {(signupError || loginError) && regularAccError && showError && (
                                        <div className="error-text small">
                                            {isSignupEmailTakenError(signupError) ? (
                                                <>
                                                    <FormattedMessage id="AuthenticationPage.signupFailedEmailAlreadyTaken" />
                                                </>
                                            ) : (
                                                <FormattedMessage id="AuthenticationPage.signupFailed" />
                                            )}
                                        </div>
                                    )}

                                    {!isAuthenticated && (
                                        <>
                                            <div className="googleSignUp">
                                                <h5>or</h5>
                                                {googleClientId && (
                                                    <GoogleLogin
                                                        className="login-w-google flex items-center justify-center"
                                                        clientId={googleClientId}
                                                        disabled={isAuthenticated}
                                                        buttonText={
                                                            <FormattedMessage id="NewPartnersPage.Setup.Account.GoogleBtn" />
                                                        }
                                                        onSuccess={responseGoogle}
                                                        onFailure={responseGoogle}
                                                        cookiePolicy={'single_host_origin'}
                                                    />
                                                )}
                                            </div>

                                            <div className="login-cta small">
                                                <FormattedMessage
                                                    id="SignupForm.termsAndConditionsAcceptText"
                                                    values={{ termsLink }}
                                                />
                                                <FormattedMessage
                                                    id="SignupForm.privacyPoliceAcceptText"
                                                    values={{ privacyLink }}
                                                />
                                            </div>

                                            <div className="login-cta small">
                                                <FormattedMessage id="SignupForm.AlreadyAccount" />{' '}
                                                <Link
                                                    to={{
                                                        pathname: '/login',
                                                        state: {
                                                            from:
                                                                location.pathname + location.search,
                                                        }, // Pass the current path as `from`
                                                    }}
                                                >
                                                    <FormattedMessage id="SignupForm.LoginTxt" />
                                                </Link>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </Form>
                        );
                    }}
                </Formik>

                <div className="step-nav flex mx-auto">
                    <div className="bullet current"></div>
                    <div className="bullet"></div>
                    <div className="bullet"></div>
                    <div className="bullet"></div>
                </div>
            </StepOneSection>
        </StepForm>
    );
};

const mapDispatchToProps = dispatch => ({
    submitLogin: ({ email, password }) => dispatch(login(email, password)),
    submitSignup: params => dispatch(signup(params)),
    submitSignupWithGoogle: params => dispatch(signUpWithGoogle(params)),
    fetchCurrentUser: params => dispatch(fetchCurrentUser()),
});

const mapStateToProps = state => {
    const { isAuthenticated, loginError, signupError } = state.Auth;
    const { planTarget } = state.subscription;
    const { currentUser } = state.user;
    return {
        authInProgress: authenticationInProgress(state),
        currentUser,
        isAuthenticated,
        loginError,
        signupError,
        planTarget,
    };
};

export default compose(injectIntl)(connect(mapStateToProps, mapDispatchToProps)(Signup));
